module.exports = __webpack_public_path__ + "img/rob_fangbao.59a1999c.png";